import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class InfrastructuresApi extends ApiModule {
	constructor() {
		super(ModulesMap.INFRASTRUCTURES, {
			entity: 'infrastructure',
		})
	}
}
